import { useShopI18n } from '../../i18n'
import { CustomerAreaPageLayout } from './customer-area'

export const CustomerInitializingPage = () => {
  const { t } = useShopI18n()

  return (
    <CustomerAreaPageLayout containerClassName="max-w-4xl">
      <div className="rounded-3xl border border-slate-200 bg-white px-6 py-5 text-slate-700 shadow-sm">
        {t('customer.initializing')}
      </div>
    </CustomerAreaPageLayout>
  )
}
